/* eslint-disable no-void */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable object-curly-newline */
/* eslint-disable max-len */
import React, { useState } from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { useTheme } from "@mui/material/styles";

import styled from "@emotion/styled";

import BasicButton from "../../../component/button/BasicButton";
import { useScreenSize } from "../../../component/Theme";

import PasswordReminderService, { PasswordReminderPayload } from "../../../logic/api/PasswordReminderService";
import { showErrorMessage } from "../../../logic/hook/useDialogStateHelper";

const passwordReminderService = new PasswordReminderService();

// パスワード再発行
const PARAMS_PASSWOED_REMIND = "0";

// SOMPOポータルで使用する変更種別アイテムキー
const ITEM_KEY_TYPE = "PWREMIND_SHOW_EMAIL";

const LINK_SUPPORT = "　";

interface PasswordReminderProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

interface PasswordReminderPropsInner extends PasswordReminderProps {
    close: () => void;
    formValues: PasswordReminderPayload;
    send: boolean;
    setSend: React.Dispatch<React.SetStateAction<boolean>>;
    handleSend: () => void;
    handleChange: React.EventHandler<React.ChangeEvent>;
}

export const ReminderTextField = styled(TextField)({
    "& label.Mui-focused": {
        color: "#c00000",
    },
    "& .MuiOutlinedInput-root": {
        background: "#F3F3F4",
        "&:hover fieldset": {
            borderColor: "#c00000",
        },
        "&.Mui-focused fieldset": {
            borderColor: "#c00000",
        },
    },
});

const Form = (props: PasswordReminderPropsInner) => {
    const { formValues, handleChange, close, handleSend } = props;
    const { desktop } = useScreenSize();

    const formStyle = { size: { sm: "small", md: "medium" }, m: 1 };
    return (
        <Grid item container direction="column" justifyContent="center" alignItems="center" sx={{ margin: "auto" }}>
            <Grid item container direction="column" justifyContent="center" sx={{ textAlign: desktop ? "center" : "left" }}>
                <Typography>以下の情報を入力し、「送信」ボタンをクリックしてください。</Typography>
                <Typography>「パスワード変更画面のURL」をメールでお知らせします。</Typography>
                <Typography>※メールアドレス欄はマイページに登録されているメールアドレス</Typography>
                <Typography>もしくはサブメールアドレスのみ入力可能です。</Typography>
            </Grid>
            <Grid item container direction="column" justifyContent="center" sx={{ mb: 2 }}>
                <ReminderTextField fullWidth label="ログインID" name="loginID" value={formValues.loginID} onChange={handleChange} sx={formStyle} />
                <ReminderTextField
                    fullWidth
                    label="登録済みメールアドレスもしくはサブメールアドレス"
                    name="email"
                    value={formValues.email}
                    onChange={handleChange}
                    sx={formStyle}
                />
            </Grid>
            <Grid item container direction="row" justifyContent="center" alignItems="center" spacing={2}>
                <Grid item container justifyContent="center" xs={5}>
                    <BasicButton disabled={!formValues.loginID || !formValues.email} onClick={() => handleSend()} label="送信" />
                </Grid>
                <Grid item container justifyContent="center" xs={5}>
                    <Button
                        sx={{
                            height: { sm: 40, md: 45 },
                            width: "150px",
                            pl: 2,
                            pr: 2,
                            borderRadius: "30px",
                            transition: "all 0.2s ease-in-out",
                            border: "1px solid #ddd",
                        }}
                        onClick={close}
                    >
                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: "14px",
                                letterSpacing: "1px",
                                color: "#333",
                            }}
                        >
                            キャンセル
                        </Typography>
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
};

const Result = (props: PasswordReminderPropsInner) => {
    const { formValues, close } = props;
    const { desktop } = useScreenSize();

    return (
        <Grid item container direction="column" justifyContent="space-between" alignItems="center" spacing={3}>
            <Grid item container direction="column" justifyContent="center" sx={{ textAlign: "center", mt: 5 }}>
                <Typography variant="h5">メールをご確認ください</Typography>
            </Grid>
            <Grid item container direction="column" justifyContent="center" sx={{ textAlign: desktop ? "center" : "left" }}>
                <Typography>{`パスワード再設定メールを ${formValues.email} 宛にお送りしました。`}</Typography>
                <Typography>お送りしたメールの内容に従ってパスワードを再設定してください。</Typography>
            </Grid>
            <Grid item container direction="column" justifyContent="center" sx={{ textAlign: desktop ? "center" : "left" }}>
                <Typography>{`${LINK_SUPPORT}`}</Typography>
            </Grid>
            <Grid item container direction="column" justifyContent="center" sx={{ textAlign: "center" }}>
                <Grid item container justifyContent="center" sx={{ mt: 5 }} xs={5}>
                    <Button
                        sx={{
                            height: { sm: 40, md: 45 },
                            width: "200px",
                            pl: 2,
                            pr: 2,
                            borderRadius: "30px",
                            transition: "all 0.2s ease-in-out",
                            border: "1px solid #ddd",
                        }}
                        onClick={close}
                    >
                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: "14px",
                                letterSpacing: "1px",
                                color: "#333",
                            }}
                        >
                            ログイン画面に戻る
                        </Typography>
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
};

const PasswordReminder = (props: PasswordReminderProps) => {
    const theme = useTheme();
    const { desktop } = useScreenSize();
    const { open, setOpen } = props;
    const [formValues, setFormValues] = useState<PasswordReminderPayload>({
        passwordChangeTypeId: "",
        loginID: "",
        email: "",
        type: "",
        inputValue: "",
    });
    const [send, setSend] = useState(false);

    // 入力時のイベント
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormValues({ ...formValues, [event.target.name]: event.target.value });
    };

    const handleSend = () => {
        const fetch = async () => {
            await passwordReminderService.passwordReminder(
                {
                    passwordChangeTypeId: PARAMS_PASSWOED_REMIND, // 固定値
                    loginID: formValues.loginID,
                    email: formValues.email,
                    type: ITEM_KEY_TYPE, // 固定値
                    inputValue: formValues.email,
                },
                () => {
                    setSend(true);
                },
                (error: any) => {
                    console.error(error);
                    showErrorMessage({ message: "送信に失敗しました。", error });
                    setSend(false);
                }
            );
        };
        void fetch();
    };

    const close = () => {
        setOpen(false);
        setSend(false);
    };

    const componentProps = {
        ...props,
        formValues,
        send,
        setSend,
        handleChange,
        handleSend,
        close,
    };

    return (
        <>
            <Modal
                open={open}
                onClose={close}
                sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Grid
                    container
                    direction="column"
                    alignItems="center"
                    flexWrap="nowrap"
                    sx={{
                        width: desktop ? "60%" : "100%",
                        minWidth: desktop ? "400px" : "auto",
                        height: desktop ? "auto" : "100%",
                        p: 5,
                        overflowY: desktop ? "none" : "scroll", // スマホ横向き対応
                        borderRadius: desktop ? "10px" : "0px",
                        bgcolor: "background.paper",
                        outline: "none",
                    }}
                >
                    <Grid
                        item
                        sx={{
                            width: "100%",
                            textAlign: desktop ? "left" : "center",
                            mb: 3,
                        }}
                    >
                        <Typography
                            variant="h5"
                            sx={{
                                color: theme.palette.primary.main,
                            }}
                        >
                            {"SOMPO Learning Hub"}
                        </Typography>
                    </Grid>
                    <Grid item sx={{ pt: 3, pb: 3 }}>
                        <Typography variant="h5">パスワード再設定</Typography>
                    </Grid>
                    <Grid item>{!send ? <Form {...componentProps} /> : <Result {...componentProps} />}</Grid>
                </Grid>
            </Modal>
        </>
    );
};

export default PasswordReminder;
